import React, { Component } from "react";
import { connect } from "react-redux";

import Users from "./Users";
import Controls from "./Controls";
//import FilterBar from "./FilterBar";
//import Bubbles from "./Bubbles";
//import Sidebar from "./Sidebar";
//import { TTP_HOME_URL, TTP_MEDIA_URL } from "Config";

//import { openSidebar, setSelectedUsers } from "Actions";
import { saveTeamSettings } from "Thunks";
import { selectRouting } from "Selectors";

import _ from "i18n";

export class Settings extends Component {
  /*allUserSelected = () => {
    const { users, selectedUsers } = this.props;

    return users.length === selectedUsers.length;
  };

  handleClickSettings = () => {
    const { dispatch } = this.props;
    dispatch(openSidebar());
  };

  handleSelectAll = () => {
    const { users, dispatch } = this.props;
    const ids = users.map(u => u.id);
    dispatch(setSelectedUsers(ids));
  };

  handleDeselectAll = () => {
    this.props.dispatch(setSelectedUsers([]));
  };

  renderNewUserLink() {
    const { pathname } = this.props.routing.location;

    const addUserLink = `${TTP_HOME_URL}/users/create`;
    const returnto = encodeURIComponent(`${TTP_MEDIA_URL}/${pathname}`);

    return (
      <a
        href={`${addUserLink}?returnto=${returnto}`}
        className="settings__newuser-link"
      >
        {_("Add new user")}
      </a>
    );
  }*/

  saveSettings() {
    const { team, saveTeamSettings } = this.props;

    let ids = [],
      titles = [],
      orders = [],
      result = [];

    for (let i = 0; i < team.length; i++) {
      ids[i] = team[i].id;
      orders[i] = team[i].order;
    }
    for (let i = 0; i < orders.length - 1; i++) {
      for (let j = i + 1; j < orders.length; j++) {
        if (orders[j] < orders[i]) {
          const help = orders[j];
          orders[j] = orders[i];
          orders[i] = help;
          const helpId = ids[j];
          ids[j] = ids[i];
          ids[i] = helpId;
        }
      }
    }
    const slogans = document.getElementsByClassName("user-slogan");
    for (let i = 0; i < slogans.length; i++) {
      titles[slogans.item(i).name.split("-")[1]] = slogans.item(i).value;
    }
    for (let i = 0; i < ids.length; i++) {
      result.push({ id: ids[i], title: titles[ids[i]] });
    }
    saveTeamSettings(result);
  }

  render() {
    const { updated, updating } = this.props;
    return (
      <div id="main" className="settings page">
        <div className="settings__filter-bar grid-x align-center">
          {/*}<FilterBar />*/}
        </div>
        <div id="setting-users" className="grid-x align-center">
          <Users />
        </div>
        {/*<div className="row align-center">
          <div className="settings__newuser small-8 grid-x align-center">
            {this.renderNewUserLink()}
          </div>
        </div>
        <Bubbles
          onClickSettings={this.handleClickSettings}
          onClickSelectAll={this.handleSelectAll}
          onClickDeselectAll={this.handleDeselectAll}
          allSelected={this.allUserSelected()}
          active={usersFetched}
        />
        <Sidebar />*/}
        <Controls
          className="display"
          ok="Apply"
          cancel="Reset"
          updated={updated}
          updating={updating}
          label={_("Apply preferences to the users")}
          action={() => this.saveSettings()}
        />
      </div>
    );
  }
}

// Connected Component
const mapStateToProps = state => ({
  routing: selectRouting(state),
  users: state.users.items,
  team: state.users.team,
  updating: state.users.updating,
  updated: state.users.updated,
  usersFetched: state.users.fetched
  //selectedUsers: state.settings.selectedUsers,
  //sidebarOpened: state.settings.sidebarOpened
});

const mapDispatchToProps = dispatch => ({
  //dispatch
  saveTeamSettings: data => dispatch(saveTeamSettings(data))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Settings);



// WEBPACK FOOTER //
// ./src/components/Settings/Settings.js